import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {ClickOutsideDirective} from "../../directives/click-outside.directive";
import { FormGroup, ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-timepicker',
  standalone: true,
  imports: [CommonModule, ClickOutsideDirective, ReactiveFormsModule],
  templateUrl: './timepicker.component.html',
  styleUrl: './timepicker.component.css'
})
export class TimepickerComponent implements OnInit, OnChanges {
  @Input() form!: FormGroup;
  @Input() controlName: string = '';
  @Input() selectedDate: Date = new Date();

  btnDisabled = false;
  isDropdownOpen = false;
  dropdownOptions: {time: string, isPastHour: boolean}[] = [];

  ngOnInit() {
    this.calcTimeSlots();
  }

  ngOnChanges() {
    this.btnDisabled = this.selectedDate.getDay() === 0;
    this.form.get(this.controlName)?.setValue('');
    this.calcTimeSlots();
  }

  calcTimeSlots() {
    this.dropdownOptions = [];
    const minTime = 9;
    const maxTime = this.selectedDate.getDay() === 6 ? 17 : 20;

    for (let hour = minTime; hour <= maxTime; hour++) {
      for (let minutes of [0, 15, 30, 45]) {
        if (hour === maxTime && minutes > 0) break;
        let h = hour.toString().padStart(2, '0');
        let m = minutes.toString().padStart(2, '0');
        const time = `${h}:${m}`;
        this.dropdownOptions.push({time, isPastHour: this.isPastHour(time)});
      }
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectTimeSlot(timeSlot: { time: string, isPastHour: boolean }) {
    if (timeSlot.isPastHour) {
      return;
    } else {
      this.isDropdownOpen = false;
      this.form.get(this.controlName)?.setValue(timeSlot.time);
    }
  }

  private isPastHour(timeSlot: string) {
    const now = new Date();
    const timeSlotForSelection= this.convertTimeStringToDate(timeSlot);
    return now.getTime() >= timeSlotForSelection.getTime()
  }

  private convertTimeStringToDate(timeSlot: string) {
    const [hours, minutes] = timeSlot.split(":").map(Number);

    return new Date(
      this.selectedDate.getFullYear(),
      this.selectedDate.getMonth(),
      this.selectedDate.getDate(),
      hours,
      minutes
    );
  }
}
